import React from 'react';
import { OeDataVM } from './oe-data.viewmodel';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';

export const OeDataContext = React.createContext<OeDataVM>(null);

export const connectOeDataVM = makeConnect(OeDataContext);
